import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/setting/tier-config/`;

const getTierConfigs = async () => {
    return await axios.get(API_URL);
};

const editTierConfig = async (tierConfigId, updatedData) => {
    return await axios.put(API_URL + tierConfigId, updatedData);
};

export default {
    getTierConfigs,
    editTierConfig
};
